/**
 * Decides what an unresolved `{{placeholder}}` renders as.
 *
 * Fault messages are translated while a request is being built, long before the
 * API returns `Fault.ContextData`, so those placeholders must survive the first
 * pass and get filled in once the fault arrives. A caller that names a variable
 * has taken responsibility for its value, so an absent value there means the
 * data is still loading and must not reach the screen as markup.
 */
export function renderUnresolvedPlaceholder(
  _text: string,
  match: RegExpExecArray,
  options: object | undefined
): string {
  const [placeholder, expression] = match;
  const variable = expression.split(',')[0].trim();
  const wasSupplied =
    options !== undefined &&
    options !== null &&
    Object.prototype.hasOwnProperty.call(options, variable);

  return wasSupplied ? '' : placeholder;
}
